import { put, call, takeLatest } from 'redux-saga/effects'
import { get, post } from '../../helpers/server'

function* getSymbolItems(action) {
    try {
        const resp = yield call(get, "/correlation/items?u=" + action.payload.UserId);
        if (resp && resp.status === 1) {
            yield put({ type: 'get_region_sector_success', symbolItems: resp.ss, sectorItems: resp.i });
        } else {
            yield put({ type: 'get_region_sector_fail', status: resp.status });
        }
    } catch (e) {
        yield put({ type: "get_region_sector_fail", status: 0 });
    }
}

function* customStock() {
    yield takeLatest('action_region_sector', getSymbolItems);

}

export default customStock;